<template>
  <PageContainer title="Listar Instrutores">
    <div v-if="!loaded" class="d-flex justify-content-center">
      <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
      </component>
    </div>

    <Box v-else class="instrutores-container" space="medium">
      <div class="header">
        <Search legend="Procurar Instrutor" placeholder="Insira nome ou CPF" :disabled="loading"
          @submit:search="submitSearch" />

        <div class="buttons">
          <Button type="button" @handle:click="updateInstrutor" text="Atualizar Instrutores" color="secondary"
            :disabled="loading">
            <Cached :size="18" />
          </Button>

          <Button type="button" @handle:click="openExportModal" text="Exportar" color="primary" :fill="false"
            :disabled="loading">
            <TrayArrowDown :size="18" />
          </Button>
        </div>
      </div>

      <div v-if="loading" class="d-flex justify-content-center">
        <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
        </component>
      </div>

      <div v-else-if="instrutores.length > 0 && !loading" class="table-container">
        <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
          @page-changed="fetchInstrutores" />

        <Table :headers="['Status', 'Instrutor', 'CPF', 'Ações']">
          <tr v-for="instrutor in instrutores" :key="instrutor.id_instrutor">
            <td>
              <Badge v-if="instrutor.flg_ativo" text="Ativo" color="success" />
              <Badge v-else text="Inativo" color="danger" />
            </td>
            <td>{{ instrutor.nome }}</td>
            <td>{{ utils.formatarCPF(instrutor.cpf) }}</td>
            <td>
              <div class="actions">
                <div v-if="instrutor.flg_ativo">
                  <IconButton @handle:click="updateStatus(instrutor.id_instrutor, 'desativar')" color="danger"
                    title="Desativar instrutor" :disabled="loadingActions">
                    <LockOutline :size="19" />
                  </IconButton>
                </div>
                <div v-else>
                  <IconButton @handle:click="updateStatus(instrutor.id_instrutor, 'ativar')" color="success"
                    title="Ativar instrutor" :disabled="loadingActions">
                    <LockOpenOutline :size="19" />
                  </IconButton>
                </div>
                <div>
                  <IconButton @handle:click="openInfoModal(instrutor.id_instrutor)" color="secondary"
                    title="Ver informações do instrutor" :disabled="loadingActions">
                    <InformationOutline :size="19" />
                  </IconButton>
                </div>
                <div>
                  <IconButton @handle:click="redirectEditor(instrutor.id_instrutor)" color="primary"
                    title="Atualizar instrutor" :disabled="!instrutor.flg_ativo || loadingActions">
                    <PencilOutline :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>

    <ExportModal ref="exportModal" @submit:export="submitExport" :loading="exportLoading" />

    <InfoModal ref="infoModal" />
  </PageContainer>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import urlApiV2 from '@/router/urlApiV2'
import utils from '../../services/utils'
import PageContainer from '../core/PageContainer'
import Box from '../core/Box'
import Search from '../core/Search'
import Button from '../core/Button.vue'
import Input from '../core/Input.vue'
import Table from '../core/Table'
import Paginate from '../core/Paginate'
import Badge from '../core/Badge.vue'
import IconButton from '../core/IconButton.vue'
import LockOutline from 'icons/LockOutline'
import LockOpenOutline from 'icons/LockOpenOutline'
import InformationOutline from 'icons/InformationOutline'
import CloudRefreshVariantOutline from 'icons/CloudRefreshVariantOutline'
import TrayArrowDown from 'icons/TrayArrowDown'
import PencilOutline from 'icons/PencilOutline'
import Cached from 'icons/Cached'
import ExportModal from '../export/ExportModal.vue'
import _export from '../../services/export'
import InfoModal from './InfoModal.vue'

export default {
  name: 'ListagemInstrutores',
  components: {
    ...spinners,
    LockOutline,
    LockOpenOutline,
    InformationOutline,
    CloudRefreshVariantOutline,
    TrayArrowDown,
    PencilOutline,
    Cached,

    PageContainer,
    Box,
    Search,
    Button,
    Input,
    Table,
    Paginate,
    Badge,
    IconButton,
    ExportModal,
    InfoModal,
  },
  data() {
    return {
      search: '',
      instrutores: [],
      paginationData: {
        currentPage: 1,
        lastPage: 0,
        total: 0,
      },
      loaded: false,
      loading: false,
      loadingActions: false,
      exportLoading: false,
      utils: utils,
    }
  },
  async created() {
    this.loaded = true

    await this.fetchInstrutores()
  },
  methods: {
    async fetchInstrutores(page = 1) {
      this.loading = true

      const params = {
        page,
      }

      if (this.search) {
        const searchType = this.validateSearch()

        if (!searchType) {
          this.loading = false

          return
        }

        searchType === 'nome' ? params.nome = this.search : params.cpf = this.search.replace(/[\.\-]/g, "")
      }

      this.filters = params

      await this.$http.get(`${urlApiV2}/instrutor/consultar`, {
        params,
      })
        .then(response => {
          const data = response.body.dados

          this.instrutores = data.data

          this.paginationData = {
            currentPage: data.current_page,
            lastPage: data.last_page,
            total: data.total,
          }
        })
        .catch(err => {
          this.toast('Erro ao buscar instrutores.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    validateSearch() {
      const cleanSearch = this.search.replace(/[\.\-]/g, "")

      if (/^\d+$/.test(cleanSearch)) {
        if (cleanSearch.length !== 11) {
          this.toast("CPF inválido.")

          return false
        }

        return "cpf"
      }

      return "nome"
    },
    async submitSearch(e) {
      this.search = e

      await this.fetchInstrutores()
    },
    async updateInstrutor() {
      this.loading = true

      await this.$http.get(`${urlApi}/getran/atualizar/instrutores`)
        .then(response => {
          this.fetchInstrutores()
        }).catch(err => {
          this.toast(err.body.dados)

          this.loading = false
        })
    },
    async submitExport(e) {
      this.exportLoading = true

      if (e.format === 'pdf') {
        await this.$http.get(`${urlApi}/instrutores/pdf/${e.initialDate}/${e.finalDate}`)
          .then(response => {
            _export.downloadPDF(response.body.dados, "instrutores")
          })
          .catch((err) => {
            this.toast("Erro ao exportar o arquivo.")
          })
          .finally(() => {
            this.exportLoading = false
          })
      } else {
        await this.$http.get(`${urlApi}/instrutores/xlsx/${e.initialDate}/${e.finalDate}`)
          .then(response => {
            _export.downloadCSV(response.body.dados, "instrutores")
          })
          .catch((err) => {
            this.toast("Erro ao exportar o arquivo.")
          })
          .finally(() => {
            this.exportLoading = false
          })
      }

      this.$refs.exportModal.close()
    },
    async updateStatus(id, status) {
      this.loadingActions = true

      await this.$http.post(`${urlApi}/instrutores/${id}/${status}`)
        .then(async response => {
          this.toast('Status atualizado!')

          await this.fetchInstrutores()
        })
        .catch(err => {
          this.toast('Erro ao atualizar status do instrutor.')
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
    redirectEditor(idInstrutor) {
      this.$router.push({ name: 'editar-instrutor', params: { idInstrutor: idInstrutor } })
    },
    openExportModal() {
      this.$refs.exportModal.open()
    },
    openInfoModal(idInstrutor) {
      this.$refs.infoModal.open(idInstrutor)
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.instrutores-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1.5rem;

  form {
    flex: 1;
    max-width: 24.125rem;
  }

  .buttons {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}

form {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  .inputs {
    flex: 1;
    max-width: 24.125rem;
  }

  .buttons {
    align-self: flex-end;

    display: flex;
    gap: 0.5rem;
  }
}

.table-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .pagination-container {
    align-self: flex-end;
  }

  .table-container {
    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}
</style>
